<template>
  <div class="container">
    <div class="task-container" v-if="taskList.length > 0">
      <div v-for="item in taskList" :key="item.id" class="list">
        <p>{{ item.title
        }}</p><span>{{
          item.releaseTime.slice(5, item.releaseTime.length - 3)
        }}</span>
      </div>
    </div>
    <null-data v-else class="null-data" />
  </div>
</template>

<script>
import { postNewInfo } from "@/network/login.js";
import nullData from "@/components/nullData.vue";

export default {
  name: "ProjectAdminNewInfo",
  components: { nullData },

  data() {
    return {
      taskList: [],
    };
  },

  mounted() {
    this.handleTaskList();
  },

  methods: {
    handleTaskList() {
      postNewInfo()
        .then((res) => {
          if (res.code === 0) {
            this.taskList = res.data.task;
          } else {
            this.$notify.error({
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.$notify.error({
            message: "请求失败，请重试！",
          });
        });
    },
  },
};
</script>

<style scoped>
.null-data {
  margin-top: -120px;
  padding: 20px 0;
}

.list {
  display: flex;
  align-items: center;
  justify-content: space-between;

  line-height: 26px;
  color: #444;
}

.list P {
  display: inline-block;
  width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.list span {
  color: #999;
}
</style>


// WEBPACK FOOTER //
// src/components/osNav/components/new-info.vue